/**
 * MATCH(짝맞추기) 열 내 중복 보기 텍스트 감지의 단일 소스.
 * 편집 중 즉시 안내(MatchTextInput)와 저장 직전 최종 게이트(useValidateQuizList)가 동일 로직을 공유한다.
 */
const normalizeMatchText = (text: string) =>
  text.trim().replace(/\s+/g, ' ').toLocaleLowerCase();

/** 정규화 후 중복되는 텍스트들의 정렬 시그니처. 중복이 없으면 빈 문자열. */
export const getDuplicateSignature = (texts: string[]) => {
  const seen = new Set<string>();
  const duplicates = new Set<string>();

  texts.forEach(text => {
    const normalizedText = normalizeMatchText(text);
    if (!normalizedText) return;

    if (seen.has(normalizedText)) {
      duplicates.add(normalizedText);
      return;
    }

    seen.add(normalizedText);
  });

  return Array.from(duplicates).sort().join('\n');
};

/** 정규화 후 중복 텍스트+개수 시그니처. 편집 중 confirm 재노출 판별용. */
export const getDuplicateCountSignature = (texts: string[]) => {
  const countsByText = new Map<string, number>();

  texts.forEach(text => {
    const normalizedText = normalizeMatchText(text);
    if (!normalizedText) return;

    countsByText.set(
      normalizedText,
      (countsByText.get(normalizedText) ?? 0) + 1,
    );
  });

  return Array.from(countsByText.entries())
    .filter(([, count]) => count > 1)
    .map(([text, count]) => `${text}:${count}`)
    .sort()
    .join('\n');
};

/** 같은 열에 중복 텍스트가 있는지 여부. */
export const hasDuplicateMatchTexts = (texts: string[]) =>
  getDuplicateSignature(texts).length > 0;
